// The page's gtag. A gtag.js install defines it globally; the container this
// repo loads doesn't, so the consent bootstrap (the first script in each
// _document) defines it and sets window.gtag. Commands pushed before the tag
// loads are queued and replayed. Only this module reads the global, and the
// overloads below are every command the codebase sends: add one before
// sending another.

type ConsentSignal = 'granted' | 'denied'

// Consent-mode signals; not this repo's ConsentState.
export type GoogleConsentState = Record<
  'ad_storage' | 'ad_user_data' | 'ad_personalization' | 'analytics_storage',
  ConsentSignal
>

export type GaField = 'client_id' | 'session_id' | 'session_number'

export type GoogleTag = {
  (
    command: 'consent',
    action: 'default' | 'update',
    state: GoogleConsentState,
  ): void
  (command: 'set', field: 'ads_data_redaction', value: boolean): void
  // Answers with the field's value, or undefined when the tag has none.
  (
    command: 'get',
    measurementId: string,
    field: GaField,
    onValue: (value: unknown) => void,
  ): void
}

export const googleTag = (): GoogleTag | undefined =>
  (window as Window & { gtag?: GoogleTag }).gtag
